<script>
	import { setContext, onDestroy } from "svelte";
	import PersistentWebSocket from "../persistentWebSocket";
	import { auth } from "../auth";
	import { baseUrl, protocol } from '../const'

	const globalFeedEvents = new EventTarget();
	setContext('GlobalFeed', globalFeedEvents);

	const globalFeedUrl = (protocol === "https:" ? "wss://" : "ws://") + baseUrl + "/global_feed"

	const globalFeedWS = new PersistentWebSocket(async () => globalFeedUrl + "?token=" + await auth.getToken())
	globalFeedWS.connect()
	globalFeedWS.addEventListener("message", handleGlobalFeedMessage)

	onDestroy(() => {
		globalFeedWS.close()
	});

	function handleGlobalFeedMessage(event) {
		if (!event.detail) {
			console.error("Received an invalid global feed websocket event:", event);
			return;
		}

		let message;
		try {
			message = JSON.parse(event.detail);
		} catch (err) {
			console.error("Error parsing JSON on global feed: ", err);
			return;
		}

		if (!message.type) {
			console.error("Received an invalid global feed message:", event);
			return;
		}

		const feedMessageEvent = new CustomEvent(message.type, {
			detail: message.data ?? message,
		});
		globalFeedEvents.dispatchEvent(feedMessageEvent);
	}
</script>

<slot />
